<template>
    <div class="card">
        <div class="card-header">
            <i class="fas fa-chalkboard me-2"></i>{{ TR.banner }}
        </div>

        <div class="card-body">
            <DADataTable
                ref="banner_table_ref"
                v-if="tableData"
                :tableData="tableData"
                :tableOptions="tableOptions"
            />
        </div>
    </div>
</template>


<script scoped>
    import { onMounted, ref, watchEffect } from "vue";
    import { useStore } from '@/system_modules/store';
    import moment from "moment-timezone";

    import { G, ajax } from "@/_common";
    import DADataTable from "@/components/table/DADataTable";

    export default {
        title: "banner",
        name: 'BannerP',

        // metaInfo: {
        //     title: 'Default App Title',
        //     titleTemplate: '%s | vue-meta Example App',
        //     htmlAttrs: {
        //         lang: 'az-AZ'
        //     },
        //     meta: [
        //         { charset: 'utf-8' },
        //         { vmid: 'description', name: 'description', content: 'An example Vue application with vue-meta.' },
        //         { vmid: 'description', name: 'viewport', content: 'width=device-width, initial-scale=1' },

        //         { property: 'og:title', content: "Epiloge - Build your network in your field of interest" },
        //         { property: 'og:site_name', content: 'Epiloge' },
        //         { property: 'og:type', content: 'website' },
        //         { property: 'og:image', content: '/users/-main.jpg' },

        //         { name: 'robots', content: 'index,follow' },
        //     ]
        // },

        components: {
            DADataTable,
        },
        setup() {
            const store = useStore();

            const tableData = ref([]);
            const tableOptions = ref();
            const banner_type = ref([
                { value: "image", label: "Image" },
                { value: "youtube", label: "Youtube" },
                { value: "video", label: "Video" }
            ]);
            const banner_table_ref = ref();
            const TR = ref({});

            onMounted(async () => {
                await ajax({
                    url: store.getBanners(),
                    success: (e) => {
                        let res = e.data || null;
                        if (res) {
                            tableData.value = res;
                            // tableData.value.forEach(x => x.create_date = new Date(x.create_date));
                            tableData.value.forEach(x => x.create_date = new Date(moment.utc(x.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss")));
                        }
                    }
                });
            });


            watchEffect(() => {
                TR.value = store.getTranslation();

                tableOptions.value = {
                    // row_total: true,
                    // row_multiple_select: true,
                    // row_total_field: ['rank'],
                    // row_per_page: 5,

                    header_buttons: [
                        {
                            private: G.privateIfNotPermission("add"),
                            label: TR.value.add_title,
                            icon: "fas fa-plus me-1",
                            class: "btn-primary",
                            eventCallback: () => {
                                G.showModal({
                                    title: TR.value.add_title,
                                    // subTitle: `<span class="text-danger1">${TR.value.name}</span>`,
                                    // modal: false,
                                    page: "components/table/DynamicTable2",
                                    // modal_width: 30,
                                    data: {
                                        permission_method: 'add'
                                    },
                                    table_columns_forlang: [
                                        {
                                            name: "title",
                                            title: TR.value.title,
                                            // value: (e) => e.translate[0].name,
                                            field_type: "text",
                                            required: true,
                                        },
                                        {
                                            name: "content",
                                            title: TR.value.text,
                                            field_type: 'editor',
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            // value: (e) => e.image,
                                            field_type: "file",
                                            fileSelectMode: 'basic',
                                            // fileSelectMode: 'advanced',
                                            fileMaxSize: G.uploadedFileSize,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        // {
                                        //     name: "title",
                                        //     title: TR.value.title,
                                        //     // value: (e) => e.translate[0].name,
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "content",
                                        //     title: TR.value.text,
                                        //     field_type: 'textarea',
                                        // },
                                        // {
                                        //     name: "image_color",
                                        //     // value: (a) => { return {'r':3,'g':68,'b':108} },
                                        //     value: (e) => {
                                        //         if( e.image_color && e.image_color != '' ){
                                        //             // let cl = e.image_color.split(',');
                                        //             return G.userHavePermission('update') ? {"r": 3, "g": 68, "b": 108 } : `<span style="padding: 4px 12px; background-color: rgb($3, 68, 108)"></span>`;
                                        //         }
                                        //         else return '';
                                        //     },
                                        //     title: TR.value.color,
                                        //     field_type: 'color',
                                        // },
                                        {
                                            name: "type",
                                            title: TR.value.type,
                                            field_type: 'dropdown',
                                            dropdown_items: banner_type.value,
                                            dropdown_item_selected: "image"
                                        },
                                        {
                                            name: "link",
                                            title: TR.value.link,
                                            field_type: 'textarea',
                                        },
                                        {
                                            name: "rank",
                                            title: TR.value.rank,
                                            value: () => 1,
                                            field_type: 'integer',
                                            max: 10000,
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: () => true,
                                            field_type: "switch",
                                            grouping: false,
                                            max: 30,
                                        },
                                    ],
                                    onModalClose: (e) => {
                                        G.closeModal(e);
                                    },
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("add"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e && e.title ){
                                                            let formData = new FormData();

                                                            if( e.image != null && typeof e.image === 'object' ){
                                                                formData.append("upload_image", e.image);
                                                            }

                                                            let banner_data = {
                                                                "link": e.link ? e.link.replace("\n|\r", "") : '',
                                                                "type": e.type,
                                                                "rank": e.rank,
                                                                // "translate": [
                                                                //     {
                                                                //         "lang_id": 1,
                                                                //         "title": e.title,
                                                                //         "content": e.content,
                                                                //     }
                                                                // ],
                                                                "translate": G.lang_list.map((a) => (
                                                                    {
                                                                        "lang_id": a.value,
                                                                        "title": e.title[a.value] || e.title[1],
                                                                        "content": e.content[a.value],
                                                                    }
                                                                )),
                                                                "status": e.status ? 1 : 0,
                                                            };

                                                            if( e.image != null && typeof e.image !== 'object' )
                                                                banner_data.image = e.image;

                                                            formData.append("data", JSON.stringify(banner_data));

                                                            await ajax({
                                                                url: store.getBanners(),
                                                                method: 'post',
                                                                data: formData,
                                                                success: (x) => {
                                                                    let res = x.data || null;
                                                                    if ( x.status == 200 && res) {
                                                                        res.create_date = new Date(res.create_date);
                                                                        // tableData.value.unshift(res);
                                                                        tableData.value.push(res);
                                                                        G.alert.success(TR.value.msg_add_success);
                                                                    }
                                                                    else
                                                                        G.alert.error(res.detail);
                                                                },
                                                                // error: (x) => {
                                                                //     var res = x.response || {};
                                                                //     if( res.status && res.status == 422 ){
                                                                //         G.alert.error({title: TR.value.warning, msg: G.getErrorMessages(res.data.detail)});
                                                                //     }
                                                                //     else
                                                                //         G.alert.error({msg: TR.value.msg_add_failed});
                                                                // }
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_title});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    row_buttons: [
                        {
                            private: G.privateIfNotPermission("remove"),
                            label: "",
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                            // eventCallback: () => {
                                // G.alert.error({
                                //     msg: 'error',
                                //     onclose: () => {
                                //         G.alert.info({
                                //             msg: 'info',
                                //             onclose: () => {
                                //                 G.alert.success({
                                //                     msg: 'success',
                                //                     onclose: () => {
                                //                         // G.alert.info();
                                //                     }
                                //                 });
                                //             }
                                //         });
                                //     }
                                // });
                                G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_are_you_sure, yesTitle: TR.value.yes, yes: async () => {
                                    await ajax({
                                        url: store.getBannersUpdate(data.id),
                                        method: 'delete',
                                        success: (e) => {
                                            let res = e.data || null;
                                            if ( e.status == 200 && res){
                                                tableData.value.filter((x, i) => { if (x.id === data.id) tableData.value.splice(i, 1); } );
                                                G.alert.success(res.detail);
                                            }
                                            else
                                                G.alert.error(res.detail);
                                        },
                                    });
                                }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {
                                    // G.alert.timer({icon: 'question', msg: 'Imtina duymesini sixdiniz !'});
                                } });
                            },
                        },
                        {
                            // private: G.privateIfNotPermission("update"),
                            label: "",
                            title: TR.value.edit,
                            // icon: "fas fa-pencil-alt",
                            // class: "btn-primary",
                            icon: "fas fa-" + ( G.userHavePermission("update") ? 'pencil-alt' : 'search' ),
                            class: "text-" + ( G.userHavePermission("update") ? 'primary' : 'info' ),
                            eventCallback: (data) => {
                                data.permission_method = 'update';

                                G.showModal({
                                    title: TR.value.edit,
                                    subTitle: data.translate[0].title,
                                    // modal_width: 30,
                                    dismiss: false,
                                    page: "components/table/DynamicTable2",
                                    data: data,
                                    table_columns_forlang: [
                                        {
                                            name: "title",
                                            // value: (l) => l.length && l[0].title != null ? l[0].title : '',
                                            value: (l) => l.title,
                                            title: TR.value.title,
                                            field_type: 'text',
                                        },
                                        {
                                            name: "content",
                                            // value: (l) => l.length && l[0].content != null ? l[0].content : '',
                                            value: (l) => l.content,
                                            title: TR.value.text,
                                            field_type: 'editor',
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            value: (e) => e.image,
                                            field_type: "file",
                                            fileSelectMode: 'basic',
                                            fileMaxSize: G.uploadedFileSize,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        {
                                            name: "id",
                                            title: TR.value.id,
                                            value: "id",
                                        },
                                        // {
                                        //     name: "title",
                                        //     value: (e) => e.translate[0].title,
                                        //     title: TR.value.title,
                                        //     field_type: 'text',
                                        // },
                                        // {
                                        //     name: "content",
                                        //     value: (e) => e.translate[0].content,
                                        //     title: TR.value.text,
                                        //     field_type: 'textarea',
                                        // },
                                        // {
                                        //     name: "image_color",
                                        //     value: (e) => {
                                        //         if( e.image_color && e.image_color != '' ){
                                        //             let cl = e.image_color.split(',');
                                        //             return G.userHavePermission('update') ? {"r": parseInt(cl[0]), "g": parseInt(cl[1]), "b": parseInt(cl[2]) } : `<span style="padding: 4px 12px; background-color: rgb(${e.image_color})"></span>`;
                                        //         }
                                        //         else return '';
                                        //     },
                                        //     title: TR.value.color,
                                        //     field_type: 'color',
                                        // },
                                        {
                                            name: "type",
                                            value: "type",
                                            title: TR.value.type,
                                            // field_type: 'text',
                                            field_type: 'dropdown',
                                            dropdown_items: banner_type.value.filter(e => e.value !== data.id),
                                            dropdown_item_selected: data.type
                                        },
                                        {
                                            name: "link",
                                            value: "link",
                                            title: TR.value.link,
                                            field_type: 'textarea',
                                        },
                                        {
                                            name: "rank",
                                            value: "rank",
                                            title: TR.value.rank,
                                            field_type: 'integer',
                                            max: 10000,
                                        },
                                        {
                                            name: "create_date",
                                            value: (e) => G.formatLocale(e.create_date),
                                            title: TR.value.create_date,
                                            field_type: "label",
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: (e) => e.status == 1 ? true : false,
                                            field_type: "switch",
                                            grouping: false,
                                            max: 30,
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("update"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e && e.title != '' ){
                                                            let formData = new FormData();
                                                            if( e.image != data.image && typeof e.image === 'object' ){
                                                                formData.append("upload_image", e.image);
                                                            }
                                                            let banner_data = {
                                                                "link": e.link ? e.link.replace("\n|\r", "") : '',
                                                                "type": e.type,
                                                                "rank": e.rank,
                                                                // "translate": [
                                                                //     {
                                                                //         "lang_id": 1,
                                                                //         "title": e.title,
                                                                //         "content": e.content,
                                                                //     }
                                                                // ],
                                                                "translate": G.lang_list.map((a) => (
                                                                    {
                                                                        "lang_id": a.value,
                                                                        "title": e.title[a.value] || e.title[1],
                                                                        "content": e.content[a.value],
                                                                    }
                                                                )),
                                                                "status": e.status ? 1 : 0,
                                                            };

                                                            if( e.image != data.image && typeof e.image !== 'object' )
                                                                banner_data.image = e.image;

                                                            formData.append("data", JSON.stringify(banner_data));

                                                            await ajax({
                                                                url: store.getBannersUpdate(data.id),
                                                                method: 'patch',
                                                                data: formData,
                                                                success: (x) => {
                                                                    let res = x.data || null;
                                                                    if (res) {
                                                                        res.create_date = new Date(res.create_date);
                                                                        tableData.value.forEach(
                                                                            (s) => { if ( s.id === res.id ) { s = res; } }
                                                                        );
                                                                        for (let a in res) {
                                                                            data[a] = res[a];
                                                                        }
                                                                        G.alert.success({msg: TR.value.msg_update_success});
                                                                    }
                                                                },
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_title});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                        {
                            private: G.privateIfNotPermission("update"),
                            name: 'status',
                            title: TR.value.status,
                            value: (e) => e.status == 0 ? false : true,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getBannersActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: (a) => {
                                        let res = a.data;
                                        G.alert.success({toast: true, msg: TR.value.msg_success});
                                        // banner_table_ref.value.loadLazyData();
                                        res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                                        tableData.value.forEach(
                                            (s) => { if ( s.id === res.id ) { s = res; } }
                                        );
                                        for (let a in res) {
                                            data[a] = res[a];
                                        }
                                    },
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        // {
                        //     name: 'status',
                        //     title: TR.value.status,
                        //     value: (e) => e.status == 0 ? false : true,
                        //     class: 'text-center',
                        //     element: 'switch',
                        //     eventName: 'change',
                        //     eventCallback: async (data, event) => {
                        //         await ajax({
                        //             url: store.getBannersActivate(data.id, event.target.checked ? 1 : 0),
                        //             method: 'post',
                        //             success: (a) => {
                        //                 let res = a.data;
                        //                 G.alert.success({msg: TR.value.msg_update_success});
                        //                 // banner_table_ref.value.loadLazyData();
                        //                 res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                        //                 tableData.value.forEach(
                        //                     (s) => { if ( s.id === res.id ) { s = res; } }
                        //                 );
                        //                 for (let a in res) {
                        //                     data[a] = res[a];
                        //                 }
                        //             },
                        //         });
                        //     },
                        //     filter: false,
                        //     sortable: false,
                        //     exportable: false,
                        // },
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },

                        {
                            name: "image",
                            value: (e) => e.type == 'video' ? '<i class="fas fa-video text-primary"></i>' : ( e.type == 'youtube' ? '<i class="fab fa-youtube text-danger"></i>' :
                                                `<img src="${
                                                        e.image && typeof e.image !== 'object' && !e.image.match(/youtu/gi)
                                                            ? e.image
                                                            : "/assets/img/noimg.png"
                                                    }"
                                                    alt="${e.image}"
                                                    class="border img-circle-cover"
                                                />`
                                            ),
                            title: TR.value.image,
                            exportable: false,
                            sortable: false,
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "translate.0.title",
                            value: (e) => e.translate[0].title,
                            title: TR.value.title,
                        },
                        {
                            name: "rank",
                            value: "rank",
                            title: TR.value.rank,
                            class: 'text-center',
                            filter: false
                        },
                        {
                            name: "link",
                            value: (e) => e.link !== '' ? '<i class="fas fa-check text-success" />' : '<i class="fas fa-square border text-white" />',
                            title: TR.value.link,
                            class: 'text-center',
                            sortable: false,
                            filter: false
                        },
                        {
                            name: "create_date",
                            value: "create_date",
                            title: TR.value.create_date,
                            class: 'text-center',
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            filter_format: 'dd.mm.yy',
                            data_type: "date",
                            filter_mode: "datetime",
                        },
                    ],
                };

            });

            // function componentToHex(c) {
            //     var hex = c.toString(16);
            //     return hex.length == 1 ? "0" + hex : hex;
            // }
            // function rgbToHex(r, g, b) {
            //     return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
            // }

            return {
                TR,
                banner_table_ref,
                tableData,
                tableOptions,
            };
        },
    };
</script>

